const IGNORED_SENDER_TYPES = new Set(["automated", "system", "internal"]);
const TEAM_SENDER_TYPES = new Set(["user", "recipient"]);

export const getMessageKey = (message, index) =>
  message?.message_id ?? message?.created_at ?? String(index);

const getCreatedAtTime = (message) => {
  const timestamp = new Date(message?.created_at || 0).getTime();
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

export const getAiReplyTargetMessageKey = (messages) => {
  const latestRelevantMessage = (Array.isArray(messages) ? messages : [])
    .map((message, index) => ({ message, index }))
    .filter(
      ({ message }) => !IGNORED_SENDER_TYPES.has(message?.sender_type),
    )
    .reduce((latest, candidate) => {
      if (!latest) return candidate;

      const latestTime = getCreatedAtTime(latest.message);
      const candidateTime = getCreatedAtTime(candidate.message);

      if (candidateTime === latestTime) {
        return candidate.index > latest.index ? candidate : latest;
      }

      return candidateTime > latestTime ? candidate : latest;
    }, null);

  if (
    !latestRelevantMessage ||
    TEAM_SENDER_TYPES.has(latestRelevantMessage.message?.sender_type)
  ) {
    return null;
  }

  return getMessageKey(
    latestRelevantMessage.message,
    latestRelevantMessage.index,
  );
};
